import { apiRoutes } from 'config/apiRoutes'
import { queryKeys } from 'config/queryKeys'
import { useMutation, useQueryClient } from 'libs/query'
import { useTranslation } from 'libs/i18n'
import { useAxiosPrivate, useToast } from 'shared/hooks'

type UseDeleteFabricMutationProps = {
	id: string | null
	onSettled: () => void
}

export const useDeleteFabricMutation = ({ id, onSettled }: UseDeleteFabricMutationProps) => {
	const { t } = useTranslation()
	const queryClient = useQueryClient()
	const axiosPrivate = useAxiosPrivate()

	const { mutate: deleteFabricMutation } = useMutation({
		mutationFn: () => {
			return axiosPrivate.delete(apiRoutes.fabric(id!))
		},
		onSuccess: () => {
			useToast({
				type: 'success',
				message: t('Fabric deleted')
			})()
			queryClient.invalidateQueries({ queryKey: queryKeys.fabrics.all })
		},
		onError: () => {
			useToast({
				type: 'error',
				message: t('Something went wrong')
			})()
		},
		onSettled: () => {
			onSettled()
		}
	})

	return {
		deleteFabricMutation
	}
}
